import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import {useNavigate} from "react-router-dom";

function HomeButton (){
    
    const navigate = useNavigate();
    
    function goHome(){
        navigate('/home');
    }
    
    return <div className='baseElementsHomeButton' onClick={goHome}></div>
}
export default HomeButton;